import { useState } from 'react';
import { fetchWithAuth } from '../../../utils/apiAuth';
import config from '../../../config';

const apiBaseUrl = config.getApiUrl();

export const useAnalytics = () => {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [analyticsError, setAnalyticsError] = useState(null);
  const [analyticsDays, setAnalyticsDays] = useState(30);

  const fetchAnalytics = async (days = 7) => {
    try {
      setAnalyticsLoading(true);
      setAnalyticsError(null);

      // Fetch hourly data for 24 hours view, otherwise fetch daily data
      if (days === 1) {
        const [hourlyResponse, referrerResponse] = await Promise.all([
          fetchWithAuth(`${apiBaseUrl}/api/analytics/hourly`),
          fetchWithAuth(`${apiBaseUrl}/api/analytics/referrers?days=1`)
        ]);

        setAnalyticsData({
          hourly: hourlyResponse.data,
          referrers: referrerResponse.data,
          isHourly: true
        });
      } else {
        // Fetch both daily and referrer analytics
        const [dailyResponse, referrerResponse] = await Promise.all([
          fetchWithAuth(`${apiBaseUrl}/api/analytics/daily?days=${days}`),
          fetchWithAuth(`${apiBaseUrl}/api/analytics/referrers?days=${days}`)
        ]);

        setAnalyticsData({
          daily: dailyResponse.data,
          referrers: referrerResponse.data,
          isHourly: false
        });
      }
    } catch (err) {
      console.error('Error fetching analytics:', err);
      setAnalyticsError(err.message);
    } finally {
      setAnalyticsLoading(false);
    }
  };

  return {
    analyticsData,
    analyticsLoading,
    analyticsError,
    analyticsDays,
    setAnalyticsDays,
    fetchAnalytics
  };
};
